import React from 'react'
import { Badge } from 'reactstrap'

interface DeviceCertPaths {
    caPath?: string
    certPath?: string
    keyPath?: string
    tlsPath?: string
    ovpnPath?: string
    [key: string]: unknown
}

interface CertificatesProps {
    device: DeviceCertPaths
}

/**
 * Render device certificates
 *
 * @param {Object} device
 * @return {*}
 */
export const Certificates = ({ device }: CertificatesProps) => (
    <>
        <a href={device.caPath} target="_blank" rel="noopener noreferrer">
            <Badge className="badge-soft-success mr-1 py-2 cursor-pointer">
                CA
            </Badge>
        </a>
        <a href={device.certPath} target="_blank" rel="noopener noreferrer">
            <Badge className="badge-soft-info mr-1 py-2 cursor-pointer">
                CERT
            </Badge>
        </a>
        <a href={device.keyPath} target="_blank" rel="noopener noreferrer">
            <Badge className="badge-soft-purple mr-1 py-2 cursor-pointer">
                KEY
            </Badge>
        </a>
        <a href={device.tlsPath} target="_blank" rel="noopener noreferrer">
            <Badge className="badge-soft-danger mr-1 py-2 cursor-pointer">
                TLS
            </Badge>
        </a>
        <a href={device.ovpnPath} target="_blank" rel="noopener noreferrer">
            <Badge className="badge-soft-dark mr-1 py-2 cursor-pointer">
                OVPN
            </Badge>
        </a>
    </>
)
